import React from 'react';

import SimpleForm from '../UI/SimpleForm';

import * as formValidation from '../../util/formValidationMethods';

const viewSettlements = ({ onSubmit, ...otherProps }) => {
    const formElements = {
        start: {
            type: 'date', 
            placeholder: 'Start', 
            validate: [formValidation.required]
        }, 
        end: {
            type: 'date', 
            placeholder: 'End', 
            validate: [formValidation.required]
        }
    };

    return (
        <SimpleForm 
            form="ViewSettlements" 
            title="View Settlements" 
            formElements={formElements} 
            onSubmit={onSubmit} 
            {...otherProps} />
    );
}

export default viewSettlements;